var _metadata, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkerActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg845",
    viewBox: "0 0 24.374 42.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata851"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs849"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-305.625 -538.997)",
    "data-name": "Raggruppa 3695",
    id: "Raggruppa_3695"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fillOpacity: 1,
      fill: "#588157"
    },
    fill: "#940000",
    transform: "translate(311.313 568)",
    "data-name": "Tracciato 4754",
    id: "Tracciato_4754"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillOpacity: 1,
      fill: "#588157"
    },
    id: "path833",
    stroke: "none",
    d: "M 6.5 12.5 C 3.191590070724487 12.5 0.5 9.808409690856934 0.5 6.5 C 0.5 3.191590070724487 3.191590070724487 0.5 6.5 0.5 C 9.808409690856934 0.5 12.5 3.191590070724487 12.5 6.5 C 12.5 9.808409690856934 9.808409690856934 12.5 6.5 12.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillOpacity: 1,
      fill: "#588157"
    },
    id: "path835",
    fill: "#fff",
    stroke: "none",
    d: "M 6.5 1 C 3.467289924621582 1 1 3.467289924621582 1 6.5 C 1 9.532710075378418 3.467289924621582 12 6.5 12 C 9.532710075378418 12 12 9.532710075378418 12 6.5 C 12 3.467289924621582 9.532710075378418 1 6.5 1 M 6.5 0 C 10.0898494720459 0 13 2.910149574279785 13 6.5 C 13 10.0898494720459 10.0898494720459 13 6.5 13 C 2.910149574279785 13 0 10.0898494720459 0 6.5 C 0 2.910149574279785 2.910149574279785 0 6.5 0 Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12409.625 11457.693)",
    "data-name": "Raggruppa 3637",
    id: "Raggruppa_3637"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12104 -10918.696)",
    id: "noun_Location_1578634"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dbd7d0",
    transform: "translate(-24 -11.9)",
    d: "M36.187,11.9A12.208,12.208,0,0,0,24,24.087C24,30.8,36.187,47.4,36.187,47.4S48.374,30.8,48.374,24.087A12.208,12.208,0,0,0,36.187,11.9Zm0,18.487a6.3,6.3,0,1,1,6.3-6.3A6.281,6.281,0,0,1,36.187,30.387Z",
    "data-name": "Tracciato 3708",
    id: "Tracciato_3708"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#dbd7d0",
    transform: "translate(-12099 -10913.696)",
    r: 7,
    cy: 7,
    cx: 7,
    "data-name": "Ellisse 519",
    id: "Ellisse_519"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerActive);
export default __webpack_public_path__ + "static/media/marker_active.28b2ed5e29818d4cc0ca5eadc628149d.svg";
export { ForwardRef as ReactComponent };